import { NcwOnboardingSlideOne } from '@capsicum/common';
import { Button } from '@capsicum/common-web';
import { type FirstSlideProps } from '@capsicum/features/nc-onboarding/shared';
import styled from 'styled-components';

import { useOnboardingSlidesTranslations } from '../../../hooks/onboarding/useOnboardingSlidesTranslations';
import { Shell } from '../../shell';
import { Description, Title } from '../Page.styled';

export const FirstSlide = ({ isLoading, onNextSlide }: FirstSlideProps) => {
	const $t = useOnboardingSlidesTranslations();

	return (
		<Shell
			cta={
				<Button
					isLoading={isLoading}
					testID="ncOnboarding-next-button"
					text={$t('ncOnboard.actions.next')}
					onClick={onNextSlide}
				/>
			}
			image={NcwOnboardingSlideOne}
		>
			{/* Adding extra vertical space since the Image height ratio is really high, taking a lot of screen */}
			<S.InvisibleDivider></S.InvisibleDivider>

			<Title color="onDark.enabled" variant="display2">
				{$t('ncOnboard.firstSlide.title')}
			</Title>

			<Description color="onDark.enabled" variant="text2">
				{$t('ncOnboard.firstSlide.description')}
			</Description>
		</Shell>
	);
};

namespace S {
	export const InvisibleDivider = styled.div`
		width: 100%;
		height: ${({ theme }) => theme.spacings.xxlarge};
	`;
}
